import { render, staticRenderFns } from "./JobApplicationsList.vue?vue&type=template&id=4564449a&scoped=true&"
import script from "./JobApplicationsList.vue?vue&type=script&lang=js&"
export * from "./JobApplicationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4564449a",
  null
  
)

export default component.exports